import { render } from "./SumProduct.vue?vue&type=template&id=794d5570"
import script from "./SumProduct.vue?vue&type=script&lang=js"
export * from "./SumProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__